export default "__VITE_ASSET__CepMdJvE__"